---
de:
  portfolio_stats:
    aggregated_intraday_hourly_revenue: Aggregierter stündlicher Intraday-Umsatz
    click_to_refresh: Zum Aktualisieren hier klicken
    heading: Portfoliostatistiken
    hourly_revenue: Stündlicher Umsatz
    hourly_revenue_warning: Das Diagramm der stündlichen Umsätze ist deaktiviert, wenn es mehr als 200 Kraftwerke gibt
    monthly_revenue: Monatliche Einnahmen
    of_budget: des Budgets
    portfolio_production: Portfolio-Produktionsübersicht
    portfolio_total: Gesamtes Portfolio
    power_plant_age_distribution: Altersverteilung der Kraftwerke
    power_plants_yearly_load_hour: Jährliche Volllaststunden
    prod_and_runoff_vs_normal: Produktion und Abfluss vs. Normal
    prod_vs_bud: Produktion vs. Budget
    prod_vs_normal: Produktion vs. Normal
    prod_vs_normal_ytd: Produktion vs. Normal YTD
    production_ytd: Produktion YTD
    rev_and_bud: Umsatz und Budget
    rev_and_bud_ytd: Umsatz und Budget YTD
    rev_vs_bud: Umsatz vs. Budget
    rev_vs_bud_ytd: Umsatz vs. Budget YTD
    revenue_ytd: Umsatz YTD
    runoff_vs_average: Abfluss im Vergleich zu Durchschnitt
    runoff_vs_normal_ytd: Produktion und Abfluss vs. Normal YTD
    technical_downtime: Übersicht über technische Ausfallzeiten
